export enum FileType {
  Customer = 'customer',
  Proof = 'proof',
  Pao = 'pao',
  Prod = 'prod'
}